import { FORMSI, PAGEI, WIDGET } from "../interfaces/page-interface";
import { WIDGET_TYPES } from "./proj.cnst";

export const SIDENAV_DATA_MODULES = {theme:'Theme', entity:'Entity', pages:'Pages',api:'API', settings:'Settings',publish:'Publish', metrics:'Metrics', dataDownload:'Data Download'};
export const SIDENAV_DATA = ['Theme', 'Entity', 'Pages','Api', 'Settings', 'Metrics', 'Data Download'];

export const SIDENAVA_META = [
  {
    label:SIDENAV_DATA_MODULES.theme,
    icon:'mdi-palette',
    link:''
  },{
    label:SIDENAV_DATA_MODULES.pages,
    icon:'mdi-window-restore',
    link:''
  },{
    label:SIDENAV_DATA_MODULES.entity,
    icon:'mdi-database',
    link:''
  },{
    label:SIDENAV_DATA_MODULES.api,
    icon:'mdi-api',
    link:''
  },{
    label:SIDENAV_DATA_MODULES.settings,
    icon:'mdi-cog',
    link:''
  },{
    label:SIDENAV_DATA_MODULES.metrics,
    icon:'mdi mdi-chart-arc',
    link:''
  },{
    label:SIDENAV_DATA_MODULES.dataDownload,
    icon:'mdi-database-arrow-down',
    link:''
  }
]

export const SIDENAV_CONTENTLIST_OPTIONS = {
  addComponent:'addComponent',widget:'widget',modifyPage:'modifyPage',promtStatus:'promtStatus',menu:'menu',nav:'Nav'
}

const responsiveOptions = {
  dragAndDrop: true,
  resizable: true,
  wSm: 1,
  wMd: 2,
  wLg: 2,
  wXl: 3,
  hSm: 1,
  hMd: 1,
  hLg: 2,
  hXl: 2,
  xSm: 2,
  xMd: 2,
  xLg: 2,
  xXl: 2,
  yMd: 2,
  yLg: 2,
  ySm: 2,
  yXl: 2
}

const responsiveOptionsForImage = {
  dragAndDrop: true,
  resizable: true,
  wSm: 1,
  wMd: 4,
  wLg: 4,
  wXl: 4,
  hSm: 1,
  hMd: 6,
  hLg: 6,
  hXl: 6,
  xSm: 2,
  xMd: 2,
  xLg: 2,
  xXl: 2,
  yMd: 2,
  yLg: 2,
  ySm: 2,
  yXl: 2
}


const responsiveOptionsForFields = {
  dragAndDrop: true,
  resizable: true,
  wSm: 1,
  wMd: 2,
  wLg: 2,
  wXl: 2,
  hSm: 1,
  hMd: 1,
  hLg: 1,
  hXl: 1,
  xSm: 2,
  xMd: 2,
  xLg: 2,
  xXl: 2,
  yMd: 2,
  yLg: 2,
  ySm: 2,
  yXl: 2
}


export const SAMPLE_MENUDATA= {
  "logo": "logo",
  "pages": [
    {
      "title": "Home",
      "enable": true
    },
    {
      "title": "About",
      "enable": true
    },
    {
      "title": "Services",
      "enable": true
    },
    {
      "title": "Contact",
      "enable": true
    }
  ],
  "userInfo":true,
  "logout":true,
}

export const SAMPLE_NAVDATA= {
  "menuIcon": "menu",
  "logo": "logo",
  "title": "Title",
  "pages": [
    {
      "title": "Home",
      "enable": true
    },
    {
      "title": "About",
      "enable": true
    },
    {
      "title": "Services",
      "enable": true
    },
    {
      "title": "Contact",
      "enable": true
    }
  ],
  "userInfo":true,
  "logout":true,
}

const FormsAndFields: WIDGET[] = [
  { widgetId: 'imageWidget1', masterWidgetId: 'f9098456-8d2c-11ee-b9d1-0242ac120002', widgetKey: '', widgetLabel: 'image', name: 'image', widgetType: WIDGET_TYPES.imageUploader, image: 'image', widgetConfig: { image: 'image', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'image', isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForImage } },
  { widgetId: 'heading1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120002", widgetKey: '', widgetLabel: "Text", name: 'Text', widgetType: WIDGET_TYPES.plainText, image: 'rich_text', widgetConfig: { image: 'rich_text', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'Text', isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {} ,values: 'Text', dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields } },
  { widgetId: 'inputCheckbox1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120010", widgetKey: '', widgetLabel: "Check Box", name: 'Check Box', widgetType: WIDGET_TYPES.singleselectcheckbox, image: 'check_box', widgetConfig: { image: 'check_box', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'checkbox', isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields }},
  { widgetId: 'inputRadio1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120009", widgetKey: '', widgetLabel: "RadioButton", name: 'RadioButton', widgetType: WIDGET_TYPES.radio, image: 'radio_button', widgetConfig: { image: 'radio_button', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'radio', isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: ['value1', 'value2',], dimentions: {x:4, y:3, w:4, h: 2},responsiveOptions: responsiveOptionsForFields } },
  { widgetId: 'inputText1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120003", widgetKey: '', widgetLabel: "Text Field", name: 'Text Field', widgetType: WIDGET_TYPES.textbox,image: 'text_placeholder', widgetConfig: { image: 'text_placeholder', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'text', isRequired: false, showlabel: true, placeholderText: 'Enter text...', additionalConfig: {}, dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields }, validations: []},
  { widgetId: 'inputFile1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120004", widgetKey: '', widgetLabel: "File Picker", name: 'File Picker', widgetType: WIDGET_TYPES.filePicker, image: 'file_picker', widgetConfig: { image: 'file_picker', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'file', isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields }},
  { widgetId: 'select1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120006", widgetKey: '', widgetLabel: "Drop Down", name: 'Drop Down', widgetType: WIDGET_TYPES.dropdown, image: 'select_dropdown', widgetConfig: { image: 'select_dropdown', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true,  isRequired: true, showlabel: true, placeholderText: 'Select value', additionalConfig: {}, values: ['Selected Option', 'option2', 'option3'], dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields }},
  { widgetId: 'inputImage1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120005", widgetKey: '', widgetLabel: "Media Upload", name: 'Media Upload', widgetType: WIDGET_TYPES.image, image: 'image_picker', widgetConfig: { image: 'image_picker', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'file', isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields }},
  { widgetId: 'inputDate1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120008", widgetKey: '', widgetLabel: "Date Picker", name: 'Date Picker', widgetType: WIDGET_TYPES.date, image: 'date_picker', widgetConfig: { image: 'date_picker', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, type: 'date', isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {} ,values: '2023-10-31', dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields }},
  { widgetId: 'inputDate1',  masterWidgetId: '2801838f-e73c-4c5b-b0ac-cc2d1df93820', widgetKey: '', widgetLabel: "Scanner", name: 'Scanner', widgetType: WIDGET_TYPES.scanner, image: 'Scanner', widgetConfig: { image: 'Scanner', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {} , dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptionsForFields }},
]


const Buttons: WIDGET[] = [
  {
    widgetId: 'button',
    masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120011',
    widgetKey: '',
    widgetLabel: 'save',
    name: 'save', 
    image: 'button',
    widgetConfig: { image: 'button', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:4, h: 1}, responsiveOptions: responsiveOptions },
    widgetType: WIDGET_TYPES.button,
  },
]

const simpleForm: WIDGET[] = [
  { widgetId: 'textbox1', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120003', widgetKey: 'MWTI', widgetLabel: 'Text1', widgetType: WIDGET_TYPES.textbox, widgetConfig:{type: 'text', placeholderText: 'Enter text...', isRequired: false, showDeletebutton: true, showlabel: true,customStyleApplied: false, style: {}, dimentions: {x:4, y:3, w:4, h: 1}, responsiveOptions: responsiveOptions }, validations: [] },
  { widgetId: 'textbox2', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120003', widgetKey: 'MW', widgetLabel: 'Text2', widgetType: WIDGET_TYPES.textbox, widgetConfig:{type: 'text', placeholderText: 'Enter text...', isRequired: false, showDeletebutton: true, showlabel: true,customStyleApplied: false, style: {}, dimentions: {x:4, y:3, w:4, h: 1}, responsiveOptions: responsiveOptions}, validations: [] },
  { widgetId: 'textbox3', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120003', widgetKey: '', widgetLabel: 'Text3', widgetType: WIDGET_TYPES.textbox, widgetConfig:{type: 'text', placeholderText: 'Enter text...', isRequired: false, showDeletebutton: true, showlabel: true,customStyleApplied: false, style: {}, dimentions: {x:4, y:3, w:4, h: 1}, responsiveOptions: responsiveOptions}, validations: []  },
  { widgetId: 'saveButton1', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120011', widgetKey: '', widgetLabel: 'form button', widgetType: WIDGET_TYPES.button,widgetConfig:{type: 'submit', isRequired: false, showDeletebutton: true, showlabel: true,customStyleApplied: false, style: { width: '100%'},values: 'Save', dimentions: {x:4, y:3, w:4, h: 1}, responsiveOptions: responsiveOptions}, validations: []}
]

const FORM_META: FORMSI[] = [
  {
    formKey: '',
    pageId: '',
    formId: 'form1',
    name: "Empty Form",
    image: 'form',
    showDeleteButton: false,
    widgets: [],
    isEditable: false,
    formConfig: {
      formType: 'form',
      style: {},
      dimentions: {x:2, y:2, w:10, h: 7},
      responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 4,
        wMd: 6,
        wLg: 6,
        wXl: 6,
        hSm: 6,
        hMd: 6,
        hLg: 6,
        hXl: 6,
        xSm: 5,
        xMd: 5,
        xLg: 5,
        xXl: 5,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      }
    }
  },
  {
    formId: 'form2',
    formKey: '',
    pageId: '',
    name: "subform",
    formConfig: {
      formType: 'subform',
      style: {},
      dimentions: {x:1, y:3, w:5, h: 5},
      responsiveOptions: responsiveOptions
    },
    image: 'custom_list',
    showDeleteButton: false,
    widgets: simpleForm,
    isEditable: false,
  },
  {
    formKey: '',
    formId: 'form1',
    name: "menu panel",
    image: 'form',
    pageId: '',
    formConfig: {
      formType: 'menuPanel',
      style: {},
      dimentions: {x:1, y:3, w:5, h: 5},
      responsiveOptions: responsiveOptions
    },
    showDeleteButton: false,
    
    widgets: [],
    isEditable: false,
  }
];

export const DEFAULT_PAGES: PAGEI[] = [
  { pageName: 'Login', applicationId: 'fds', name: 'Login', image: 'image_picker',pageType:'' },
  { pageName: 'Landing Page', applicationId: 'fds', name: 'Landing Page', image: 'searchable_dropdown',pageType:'' }
]

export const CUSTOM_PAGES: PAGEI[] = [
  { pageName: 'Blank Page', applicationId: '', name: 'Blank Page', image: 'image_picker',pageType:'' },
]

export const Authentication = DEFAULT_PAGES;

export const Custom = CUSTOM_PAGES;

const displayWidgets: WIDGET[] = [
  { 
    widgetId: 'barchart', 
    masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120012",
    widgetKey: '',
    widgetLabel: 'Bar Chart',
    name: 'Bar Chart', 
    image: 'bar_chart',
    widgetType: WIDGET_TYPES.barChart,
    widgetConfig: { 
      image: 'button', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 2,
        wMd: 6,
        wLg: 6,
        wXl: 6,
        hSm: 8,
        hMd: 15,
        hLg: 15,
        hXl: 15,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      }
   },
  }, 
  { 
    widgetId: 'lineChart', 
    masterWidgetId : "ae913c6e-837e-11ee-f962-0452ac123412",
    widgetKey: '',
    widgetLabel: 'Line Chart',
    name: 'Line Chart', 
    image: 'line_chart',
    widgetType: WIDGET_TYPES.lineChart,
    widgetConfig: { 
      image: 'button', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 2,
        wMd: 6,
        wLg: 6,
        wXl: 6,
        hSm: 15,
        hMd: 15,
        hLg: 15,
        hXl: 15,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      }
   },
  }, 
  { 
    widgetId: 'pieChart', 
    masterWidgetId : "ae913c6e-837e-11ee-b962-0452ac123412",
    widgetKey: '',
    widgetLabel: 'Pie Chart',
    name: 'Pie Chart', 
    image: 'pie_chart',
    widgetType: WIDGET_TYPES.pieChart,
    widgetConfig: { 
      image: 'button', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 2,
        wMd: 6,
        wLg: 6,
        wXl: 6,
        hSm: 4,
        hMd: 15,
        hLg: 15,
        hXl: 15,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      }
   },
  },
  { 
    widgetId: 'map', 
    masterWidgetId : "ae913c6e-837e-11ee-b962-0672ac123412",
    widgetKey: '',
    widgetLabel: 'Map',
    name: 'Map', 
    image: 'geofence',
    widgetType: WIDGET_TYPES.map,
    widgetConfig: { 
      image: 'map', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 2,
        wMd: 2,
        wLg: 3,
        wXl: 5,
        hSm: 4,
        hMd: 6,
        hLg: 8,
        hXl: 20,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      },
      coordinates : [52.132, 5.2913],
    },
  },
  { 
    widgetId: 'Table', 
    masterWidgetId : "ae913c6e-837e-13ee-f962-0452ac123412",
    widgetKey: '',
    widgetLabel: 'Table',
    name: 'Table', 
    image: 'table',
    widgetType: WIDGET_TYPES.table,
    widgetConfig: { 
      image: 'map', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 6,
        wMd: 15,
        wLg: 15,
        wXl: 15,
        hSm: 4,
        hMd: 10,
        hLg: 10,
        hXl: 10,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      },
      coordinates : [52.132, 5.2913],
    },
  },
  { 
    widgetId: 'stackBarChart', 
    masterWidgetId : "ae913c6e-837e-11ee-b962-0452ac123412",
    widgetKey: '',
    widgetLabel: 'Stackbar Chart',
    name: 'Stackbar Chart', 
    image: 'stack_bar_chart',
    widgetType: WIDGET_TYPES.stackBarChart,
    widgetConfig: { 
      image: 'button', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 2,
        wMd: 6,
        wLg: 6,
        wXl: 6,
        hSm: 4,
        hMd: 15,
        hLg: 15,
        hXl: 15,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      }
   },
  },
  { 
    widgetId: 'donutChart', 
    masterWidgetId : "ae913c6e-837e-11ee-b962-0452ac123412",
    widgetKey: '',
    widgetLabel: 'Donut Chart',
    name: 'Donut Chart', 
    image: 'donut',
    widgetType: WIDGET_TYPES.donutChart,
    widgetConfig: { 
      image: 'button', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 2,
        wMd: 6,
        wLg: 6,
        wXl: 6,
        hSm: 4,
        hMd: 15,
        hLg: 15,
        hXl: 15,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      }
   },
  },
  { 
    widgetId: 'fixedBarChart', 
    masterWidgetId : "ae913c6e-837e-51ee-b962-0452ac123412",
    widgetKey: '',
    widgetLabel: 'FixedBar Chart',
    name: 'FixedBar Chart', 
    image: 'fixedBar',
    widgetType: WIDGET_TYPES.fixedBarChart,
    widgetConfig: { 
      image: 'button', style: {width: '100%'}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {}, values: 'Next', dimentions: {x:4, y:3, w:3, h: 3}, responsiveOptions: {
        dragAndDrop: true,
        resizable: true,
        wSm: 2,
        wMd: 2,
        wLg: 3,
        wXl: 6,
        hSm: 4,
        hMd: 6,
        hLg: 8,
        hXl: 20,
        xSm: 2,
        xMd: 2,
        xLg: 2,
        xXl: 2,
        yMd: 2,
        yLg: 2,
        ySm: 2,
        yXl: 2
      }
   },
  },
]

const addOns: any[] = [
  {
    widgetId: "separator",
    index: 3,
    masterWidgetId: "f9098456-8d2c-11ee-b9d1-0242ac120002",
    key: "",
    name: "Separator",
    widgetType: WIDGET_TYPES.separator,
    image: "separation",
    widgetConfig: { image: '', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {} , dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptions }
  },
  {
    widgetId: "geotag",
    index: 3,
    masterWidgetId: "f9098456-8d2c-11ee-b9d1-0242ac120002",
    key: "",
    name: "Geotag",
    widgetType: WIDGET_TYPES.geotag,
    image: "geotag",
    widgetConfig: { image: '', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {} , dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptions }
  },
  {
    widgetId: "address",
    index: 3,
    masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120003",
    key: "",
    name: "Address",
    widgetType: WIDGET_TYPES.address,
    image: "address",
    widgetConfig: { image: '', style: {}, actions: [], customStyleApplied: false, showDeletebutton: true, isRequired: true, showlabel: true, placeholderText: '', additionalConfig: {} , dimentions: {x:4, y:3, w:4, h: 2}, responsiveOptions: responsiveOptions }
  }
];


export const CATEGORIES_META_DATA: { type: string, items: (WIDGET | FORMSI)[] }[] = [
  { type: 'Forms & Fields', items: FormsAndFields },
  { type: 'Buttons', items: Buttons },
  { type: 'Add Ons', items:  addOns},
  { type: 'Display', items: displayWidgets}
]

